<app-dialog-wrapper
    heading="common.set-request-active-dialog.title"
    description="common.set-request-active-dialog.description"
    confirmLabel="common.set-request-active-dialog.confirm"
    cancelLabel="common.general.cancel"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
</app-dialog-wrapper>
